export default "__VITE_ASSET__635a0bf1__"